import {Controller} from '@hotwired/stimulus';

export default class NavScrollController extends Controller {
  static targets = ['nav'];

  connect() {
    this.lastScrollPosition = window.scrollY;
    this.handleScroll = this.handleScroll.bind(this); // Bind the method for proper context
    window.addEventListener('scroll', this.handleScroll);
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    var currentScrollPosition = window.scrollY < 0 ? 0 : window.scrollY;

    // Hide when scrolling down past the top; always reveal on any upward scroll.
    if (currentScrollPosition > this.lastScrollPosition && currentScrollPosition > 60) {
      this.element.classList.add('hidden')
    } else if (currentScrollPosition < this.lastScrollPosition) {
      this.element.classList.remove('hidden')
    }

    this.lastScrollPosition = currentScrollPosition;
  }
}
